import React from "react";
import Button from "../../components/button";
import { scrollToTop } from "../../utilities/utils";

const HealthPrioritizeHomePage = ({ title }) => {
  return (
    <div className="pb-[100px]">
      <div className="container text-center">
        <h2 className="mb-[30px]">{title}</h2>
        <p className="text-[18px] md:text-[20px] leading-[180%] font-normal text-[#485868] max-w-[1063px] mx-auto mb-[50px]">
          At HelpMatch, we believe everyone should have access to high quality
          medical providers. We wont match you with a big corporate clinics
          owned by some private equity firm, but instead with a highly skilled
          and top-rated independent, local professional who is loved by their
          existing patients and has appointment availability to help you now.
          Our providers are dedicated to delivering high-quality care, with a
          commitment to your health and well-being - without compromise.
        </p>
        <Button
          title="get matched now"
          classes="text-base leading-[160%] font-black text-bodyColor bg-primary rounded-[10px] py-3 md:py-6 md:px-10 uppercase w-full md:w-auto duration-500 hover:bg-[#026ed6] capitalize"
          onClick={() => scrollToTop()}
        />
      </div>
    </div>
  );
};

export default HealthPrioritizeHomePage;
